<script setup lang="ts">
import { useRoute } from 'vue-router';
import { i18n } from '@/i18n';

const t = i18n.t;
const route = useRoute();
</script>
<template>
  <div class="tab__container">
    <router-link to="/firm-order">
      <div :class="route.path === '/firm-order' ? 'tab__active' : 'tab__inactive'">{{ t('テーブル(発注ページ)') }}</div>
    </router-link>
    <router-link to="/order-calendar">
      <div :class="route.path === '/order-calendar' ? 'tab__active' : 'tab__inactive'">{{ t('カレンダー(発注ページ)') }}</div>
    </router-link>
  </div>
</template>
<style lang="scss" scoped>
.tab {
  &__container {
    min-height: 40px;
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-gap: 16px;
    justify-content: start;
  }

  &__active {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: center;
    border-bottom: 2px solid #1e92ef;
    color: #212121;
    padding: 8px 0;
    height: 100%;
    align-content: center;
  }

  &__inactive {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: center;
    color: $textSecondary;
    padding: 8px 0;
    height: 100%;
    align-content: center;
  }
}
</style>
